var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.0001C0 4.48011 4.47 0.000107765 10 0.000107765C15.52 0.000107765 20 4.48011 20 10.0001C20 15.5301 15.52 20.0001 10 20.0001C4.47 20.0001 0 15.5301 0 10.0001ZM12.2301 11.8301L13.8501 6.71011C13.9601 6.36011 13.6401 6.03011 13.2901 6.14011L8.17013 7.74011C7.96013 7.81011 7.79013 7.97011 7.73013 8.18011L6.13013 13.3101C6.02013 13.6501 6.35013 13.9801 6.69013 13.8701L11.7901 12.2701C12.0001 12.2101 12.1701 12.0401 12.2301 11.8301Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/internet.657b9ed2.svg";
export { ForwardRef as ReactComponent };